import { defineNuxtPlugin } from 'nuxt/app';

type Callback = (arg?: unknown) => unknown;

// functional approach
function addEvent (
  evts: Record<string, Callback[] | undefined>,
  evtName: string,
  callbacks: Callback[],
) {
  if (!evts[evtName]) {
    evts[evtName] = [];
  }
  evts[evtName].push(...callbacks);
}

function removeEvent (
  evts: Record<string, Callback[] | undefined>,
  evtName: string,
  callbacks: Callback[],
) {
  if (evts[evtName]) {
    if (callbacks?.length) {
      evts[evtName] = evts[evtName].filter(cb => !callbacks.includes(cb));
    } else {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete evts[evtName];
    }
  }
}

function triggerEvent (
  evts: Record<string, Callback[] | undefined>,
  evtName: string,
  evtPayload: unknown,
) {
  const callbacks = evts[evtName];
  if (callbacks) {
    for (let i = 0; i < callbacks.length; i++) {
      const callback = callbacks[i];
      if (callback && typeof callback === 'function') {
        callback(evtPayload);
      }
    }
  }
}

// obj oriented approach
class AwEvents {
  _events: Record<string, Callback[] | undefined> = {};

  addEvent (eventName: string, ...callbacks: Callback[]) {
    addEvent(this._events, eventName, callbacks);
  }

  removeEvent (eventName: string, ...callbacks: Callback[]) {
    removeEvent(this._events, eventName, callbacks);
  }

  triggerEvent (eventName: string, evtPayload?: unknown) {
    triggerEvent(this._events, eventName, evtPayload);
  }
}

function createPluginProvides () {
  return {
    awEvents: new AwEvents(),
  };
}

export type AwEventsPluginProvides = ReturnType<typeof createPluginProvides>;

export default defineNuxtPlugin(() => {
  return {
    provide: createPluginProvides(),
  };
});
